export default __webpack_public_path__ + "static/media/profile.2fbd2bc9.svg";